<template>
  <div class="error">
    <p class="title">404</p>
    <p class="desc">Похоже, мы не можем найти<br>нужную Вам страницу</p>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>

<style lang="scss" scoped>
.error {
  .title {
    font-weight: 400;
    font-size: 280px;
  }
  .desc {
    font-weight: 400;
    font-size: 48px;
    margin-top: 40px;
  }
}
</style>
